import { objectDuckCreator } from '@atc/modular-redux';

export default objectDuckCreator({
    store: 'expiredListing',
    initialState: {},
});
